import Dropdown, { useDropdownOutside } from '@anm/components/Dropdown';
import {
  DropdownContent,
  DropdownItemWrapper,
  FormatsWrapper,
  FormatIconContainer
} from '@anm/components/templates/VideoAspectsDropdown';
import { DEFAULT_DROPDOWN_DELAY } from '@anm/constants/delays';
import aspectDropdownData from '@anm/data/video-templates/aspect-dropdown';
import isMobile from '@anm/helpers/is/isMobile';
import { FC } from 'react';

import { useDropdownHandler } from './hooks';

const VideoAspectsDropdown: FC = () => {
  const [activeItemIndex, handleItemClick] = useDropdownHandler();

  const [
    isOpened,
    handleOpenDropdown,
    handleCloseDropdown
  ] = useDropdownOutside();

  return (
    <FormatsWrapper isOpenDropdown={isOpened}>
      <Dropdown
        isModalOnMobile
        direction="to-bottom"
        onOpen={handleOpenDropdown}
        onClose={handleCloseDropdown}
        openDelay={DEFAULT_DROPDOWN_DELAY}
        closeDelay={DEFAULT_DROPDOWN_DELAY}
        renderContent={() => (
          <DropdownContent
            selectedIndex={activeItemIndex}
            onItemClick={handleItemClick}
          />
        )}
      >
        <DropdownItemWrapper isPlaceholder isSelected={false}>
          <FormatIconContainer {...aspectDropdownData[activeItemIndex]} />
          {!isMobile() && aspectDropdownData[activeItemIndex].title}
        </DropdownItemWrapper>
      </Dropdown>
    </FormatsWrapper>
  );
};

export default VideoAspectsDropdown;
